import { TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE } from "../shared/abstract-boxes";

export function AiSatisfactionBoxViewConstructor(services) { // , callbacks, context, siteTypeConfig
  let joint = services.joint;

  return joint.shapes.html.AbstractBoxElementWithDragAndDropView.extend({
    isElementEditable: true,
    editElementModalController: 'editAiSatisfactionDescriptionController',
    editElementModalTemplate: require('./edit-ai-satisfaction-description.modal.html'),


    angularTemplate: `
<div class="ai-satisfaction">
  {{ elementData.descriptionLabel }}
</div>
`,
    initialize: function () {
      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);
      setTimeout(() => this.updateValidity(), 200);
    },

    createOutput: function (id, position = TMP_ELEMENT_POSITION, size = TMP_ELEMENT_SIZE, elementData) {
      return new joint.shapes.html.AiSatisfactionAnswerExit({ id, position, size, elementData });
    },

    isChildAlwaysLast: function (child) {
      return 'html.UserInput' === child.get('type');
    },

    paddingTop: function () {
      return this.heightOfHTMLContent();
    },

    afterEditElement: function () {
      this.updateValidity();
    },

    updateValidity: function () {
      if (!this.angularScope.elementData) {
        this.model.setBoxValid(false);
      } else {
        this.angularScope.elementData.references = {
          yesBoxId: null,
          noBoxId: null
        };

        const children = this.model.getEmbeddedCells().filter((child) => child.get('type') !== 'html.UserInput');
        let yesLabel = null;
        let noLabel = null;

        children.forEach(child => {
          if (child.get('elementData')) {
            const { type, label } = child.get('elementData');
            if (type === 'Yes') {
              yesLabel = label;
              this.angularScope.elementData.references.yesBoxId = child.id;
            } else if (type === 'No') {
              noLabel = label;
              this.angularScope.elementData.references.noBoxId = child.id;
            }
          }
        });

        const { descriptionLabel } = this.angularScope.elementData;

        this.model.setBoxValid(descriptionLabel && yesLabel && noLabel);

        // The watch mecanism to refresh the elementData model is not triggered when the change comes from the children.       
        this.model.set('elementData', this.angularScope.elementData);
      }

    },
  });
}
